import { Outlet } from 'react-router-dom';
import NoAccess from '../psc/lib/NoAccess'

import useAuthentication from '../../hooks/useAuthentication';
import useUserManagement from '../../hooks/useUserManagement';

const RequireRole = (props) => {
    const role = props.role
    const {
        userHasRole,
    } = useUserManagement()
    
    const { currentUser } = useAuthentication();

    const hasRole = userHasRole(currentUser, role)

    if( ! hasRole ) {
        return (<NoAccess/>)
    }

    return (
        <Outlet />
    )
};

export default RequireRole
